// @flow
import React from 'react';
import type { LetterSequence } from 'store/modules/letters';
import { fromNow } from 'lib/common';
import { Link } from 'react-router-dom';
import FakeLink from 'components/common/FakeLink';
import cx from 'classnames';
import './LetterSequences.scss';

type LetterSequenceItemProps = {
  sequence: LetterSequence,
  username: string,
  active: boolean,
};

type Props = {
  sequences: ?(LetterSequence[]),
  username: string,
  currentLetterId: string,
};

const LetterSequenceItem = ({ sequence, username, active }: LetterSequenceItemProps) => {
  const { title, body, meta, url_slug, created_at } = sequence;
  const to = `/@${username}/letters/${url_slug}`;
  return (
    <FakeLink className={cx('LetterSequenceItem', { active })} to={to}>
      <div className="date">{fromNow(created_at)}</div>
      <div className="title">
        <Link to={to}>{title}</Link>
      </div>
      <p>{(meta && meta.short_description) || body}</p>
    </FakeLink>
  );
};

const LetterSequences = ({ sequences, username, currentLetterId }: Props) => {
  if (!sequences || sequences.length === 0 || sequences.length === 1) return null;
  return (
    <div className="LetterSequences">
      <div className="wrapper">
        <h3 className="title">다른 뉴스레터 둘러보기</h3>
        {sequences.map(s => (
          <LetterSequenceItem
            key={s.id}
            sequence={s}
            username={username}
            active={s.id === currentLetterId}
          />
        ))}
      </div>
    </div>
  );
};

export default LetterSequences;



// WEBPACK FOOTER //
// ./src/components/letter/LetterSequences/LetterSequences.js